import * as Luxon from 'luxon'
import { getAllPosts } from '../api/posts'
import Page from 'components/Page'
// import Content from 'components/Content'
import { GetStaticProps } from 'next'
import BlogLink from 'components/BlogLink'
import * as styles from './blogIndex.module.css'
import BlogContent from 'components/BlogContent'
import Html from 'components/Html'
import Heading from 'components/Heading'
// import Html from 'components/Html'

export default function BlogPosts(props) {
  return <Page
    title={`Blog - ${props.title}`}
    description={props.description}
  >
    <BlogContent isPost={false}>
      <div className={styles.header}>
        <Heading level={3} className={styles.blogSubtitle}>A blog about making things happen</Heading>
      </div>
      <div className={styles.articleList}>
        {props.posts.map((post, idx) =>
          <article key={idx} className={styles.postCard}>
            <div className={styles.postCardInside}>
              { post.imageThumbPath &&
                <BlogLink slug={post.slug}>
                  <a className={styles.postCardThumbnail}>
                    <img className={styles.thumbnail} src={`/static/images/blog/${ idx === 0 ? post.imagePath : post.imageThumbPath}`} alt={post.imageAlt} />
                  </a>
                </BlogLink>
              }
              <div className={styles.postCardContent}>
                <header className={styles.postHeader}>
                  <div className={styles.postMeta}>
                    <time
                      className={styles.published}
                      dateTime={Luxon.DateTime.fromISO(post.date).toLocaleString(Luxon.DateTime.DATE_HUGE)}>
                        { Luxon.DateTime.fromISO(post.date).toLocaleString(Luxon.DateTime.DATE_HUGE) }
                    </time>
                  </div>
                  <h2 className={styles.postTitle}>
                    <BlogLink slug={post.slug}>
                      <a>
                        <Html>{post.title}</Html>
                      </a>
                    </BlogLink>
                  </h2>
                </header>
                <div className={styles.postExcerpt}>
                  { post.excerpt && <>
                    <p><Html>{post.excerpt}</Html></p>
                    <p className={styles.readMore}>
                      <BlogLink slug={post.slug}>
                        <a className={styles.buttonSecondary}>Read more...</a>
                      </BlogLink>
                    </p>
                  </> }
                </div>
              </div>
            </div>
          </article>
        )}
      </div>
    </BlogContent>
  </Page>
}

export const getStaticProps: GetStaticProps = async () => {
  const allPosts = await getAllPosts()
  return {
    props: {
      posts: allPosts,
      title: 'Side Hustle Cool Blog',
      description: 'Probably the best blog you’ve ever seen',
    }
  }
}
